import React from 'react';
import { FormattedNumber, IntlProvider, useIntl } from 'react-intl';
import Promo from '../PromoTag';
import Image from '../../UI/Image/Image';
import { ISelectedCarrier } from '../../ReservePhoneBlade/types';
import {
  CarrierLogoWrapper,
  CarrierOfferWrapper,
  CollapsedContainer,
  DetailLabel,
  MonthlyPrice,
  NoPromo,
  Price,
  PromoWrapper,
  UpFrontPrice,
} from './styles';

interface Props {
  carrier: ISelectedCarrier;
  variantLabels: Record<string, any>;
}

const SelectedCarrier = ({ carrier, variantLabels }: Props) => {
  const intl = useIntl();

  return (
    <CarrierOfferWrapper>
      <CollapsedContainer>
        {/* Carrier Logo */}
        <CarrierLogoWrapper>
          <Image image={carrier.carrierImg} />
        </CarrierLogoWrapper>
        {/* UpFrontPrice */}
        <UpFrontPrice>
          <Price>
            <IntlProvider locale={`${intl.locale}-CA`}>
              <FormattedNumber
                value={carrier.carrierUpfrontCost}
                // eslint-disable-next-line react/style-prop-object
                style="currency"
                currency="CAD"
                maximumFractionDigits={2}
                minimumFractionDigits={2}
              />
            </IntlProvider>
          </Price>
          {/* TODO Replace with field names */}
          <DetailLabel>{variantLabels['6KcxYb1EQRl64daz8jTntc']}</DetailLabel>
        </UpFrontPrice>
        {/* MonthlyPrice */}
        <MonthlyPrice>
          <Price>
            <IntlProvider locale={`${intl.locale}-CA`}>
              <FormattedNumber
                value={carrier.carrierMonthlyCost}
                // eslint-disable-next-line react/style-prop-object
                style="currency"
                currency="CAD"
                maximumFractionDigits={2}
                minimumFractionDigits={2}
              />
            </IntlProvider>
          </Price>
          <DetailLabel>{variantLabels.aOC9eaI5Lh49zWX8rqb2Y}</DetailLabel>
        </MonthlyPrice>
        {/* PCO POINTS */}
        {carrier.carrierPcoPoints > 0 ? (
          <PromoWrapper>
            <Promo isDetailPage bestValueOffer={carrier.carrierPcoPoints} />
            {/* TODO Replace with field names */}
            <DetailLabel>{variantLabels['2TzLWT8BmcdnnFz6XPkKCA']}</DetailLabel>
          </PromoWrapper>
        ) : (
          <NoPromo />
        )}
      </CollapsedContainer>
    </CarrierOfferWrapper>
  );
};

export default SelectedCarrier;
